<template>
  <a-modal v-model="visible" title="插入模板-气泡1" @ok="handleOk">
    <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="气泡文字">
        <a-input v-model="bubble.content"/>
      </a-form-model-item>
  </a-form-model>
</a-modal>
</template>

<script>
export default {
  name: 'Bubble1',
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      bubble: {
        title: undefined,
        content: undefined
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleOk() {
      let jsonStr = JSON.stringify({content: this.bubble.content})
      console.log(jsonStr)
      let content = '<span id="aaa" class="fm_window mceNonEditable" data-name="Bubble1" data-json=' + jsonStr + '><span class="tip_img"><!--nocontent--></span><span class="background" hidden><!--nocontent--></span><span class="fm_window_content" hidden>'
        + this.bubble.content + '<span class="header-right"><!--nocontent--></span></div></span>'
      // this.$emit('ok', {content: content})
      this.$emit('replace', {content: content})
      this.visible = false
    },
    setData(json) {
      let data = JSON.parse(json)
      console.log(data)
      this.bubble.content = data.content
    }
  }
}
</script>

<style>

</style>